<template>
    <div class="footer_wrap">
        <div class="footer">
            <div class="footer_left">
                <div class="footer_text">
                    <div class="footer_text_li" v-for="(item,index) in company_list" :key="index">
                        <b>{{item.company_name}}</b>
                        <span v-html="item.company_address"></span>
                        <i>{{item.contact_tel}}</i>
                        <em>{{item.email}}</em>
                    </div>
                </div>
            </div>
            <div class="footer_right">
                <div class="footer_logo" @click="to_index()">
                    <img src="../../static/images/logo_white.png" alt="">
                </div>
                <div class="ewm_li">
                    <b><img :src="siteInfo.qrcode" alt=""></b>
                    <span>微信公众号</span>
                </div>
            </div>
        </div>
        <div class="copyright">
            <div class="copyright_nr">
                <b>{{siteInfo.copyright}}</b>
                <span @click="to_icp()">{{siteInfo.icp}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'myFooter',
    data () {
        return {
            siteInfo:{},
            company_list:[]
        }
    },
    created () {
        this.pageSiteMsg();
        this.pageData();
    },
    methods:{
        pageSiteMsg(){
            let siteMsg = JSON.parse(localStorage.getItem('site_msg'));
            if(siteMsg){
                this.siteInfo = siteMsg;
            }else{
                this.$api.siteMsg().then(res => {
                    this.siteInfo = res.data.siteMsg;
                    let site_msg = JSON.stringify(res.data.siteMsg);
                    localStorage.setItem('site_msg',site_msg);
                });
            }
        },
        pageData(){
            this.$api.companyList().then(res => {
                this.company_list = res.data;
                console.log(this.company_list);
            });
        },
        to_index(){
            this.$router.push({
                path:'/'
            });
        },
        to_icp(){
            let links = 'https://beian.miit.gov.cn/';
            window.open(links, '_blank')
        },

    },
}
</script>


<style scoped>
.footer_wrap{width:100%;min-height:420px;height:auto;display:block;float:left;background:url(../../static/images/footer_bg.jpg) top no-repeat;
    background-size:1920px 100%;}
.footer{width:1200px;min-height:420px;height:auto;display:block;float:left;position:relative;left:50%;margin-left:-600px;margin-top:0;padding:40px 0 10px;}
.footer_left{width:80%;min-height:280px;height:auto;display:inline-block;float:left;}
.footer_text{width:100%;min-height:115px;display:flex;float:left;padding-top:5px;flex-wrap:wrap;flex-direction:row;}
.footer_text .footer_text_li{width:450px;min-height:115px;display:block;float:left;position:relative;height:auto;
    font-size:14px;color:#fff;padding:5px 0;line-height:20px;margin-left:60px;border-bottom:1px solid;border-color:rgba(255,255,255,0.1);}
.footer_text .footer_text_li:nth-child(2n-1){margin-left:0;}
.footer_text .footer_text_li b{width:100%;min-height:24px;font-size:15px;color:#fff;float:left;line-height:20px;}
.footer_text .footer_text_li span{color:#fff;opacity:0.8;min-height:20px;height:auto;width:100%;font-size:13px;
    line-height:20px;display:block;float:left;}
.footer_text .footer_text_li em{color:#fff;opacity:0.8;min-height:20px;height:auto;width:100%;font-size:13px;
    line-height:20px;display:block;float:left;font-style:normal;}
.footer_text .footer_text_li em i{display:inline;}
.footer_text .footer_text_li i{color:#fff;opacity:0.8;height:20px;width:100%;font-style:normal;font-size:13px;
    line-height:20px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block;}
.footer_right{width:20%;height:220px;display:inline-block;float:left;text-align:right;}
.footer_right .ewm_li{width:120px;height:150px;display:inline-block;margin-right:25px;}
.footer_right .ewm_li b{width:100%;height:120px;display:block;float:left;overflow:hidden;}
.footer_right .ewm_li b img{width:100%;height:auto;display:block;}
.footer_right .ewm_li span{width:100%;min-height:20px;font-size:12px;color:#fff;display:block;
    text-align:center;float:left;margin-top:10px;opacity:0.7;}
.footer_right .footer_logo{width:100%;height:70px;display:block;float:left;cursor:pointer;text-align:right;padding-bottom:20px;}
.footer_right .footer_logo img{height:50px;width:auto;display:inline-block;}
.copyright{width:100%;height:40px;display:block;float:left;background:#303030;padding:10px 0;}
.copyright_nr{width:1200px;height:20px;display:block;margin:0 auto;overflow:hidden;font-size:12px;
    color:#fff;line-height:20px;text-align:center;font-weight:normal;}
.copyright_nr b{font-weight:normal;display:inline-block;opacity:0.6;}
.copyright_nr span{color:#fff;cursor:pointer;margin-left:20px;opacity:0.6;}
.copyright_nr span:hover{opacity:2.0;color:#fff;}
@media (min-width:992px) and (max-width:1200px){
    .footer_wrap{width:100%;min-height:380px;height:auto;background:url(../../static/images/footer_bg.jpg) top no-repeat;
        background-size:1920px 100%;}
    .footer{width:1000px;min-height:380px;margin-left:-500px;padding:10px 0;}
    .footer_left{width:100%;min-height:280px;display:inline-block;float:left;}
    .footer_text{width:100%;min-height:115px;display:flex;float:left;padding-top:5px;}
    .footer_text .footer_text_li{width:450px;min-height:115px;display:block;float:left;position:relative;height:auto;
        font-size:14px;color:#fff;padding:5px 0;line-height:20px;margin-left:60px;border-bottom:1px solid;border-color:rgba(255,255,255,0.1);}
    .footer_text .footer_text_li:nth-child(2n-1){margin-left:0;}
    .footer_right{display:none;}
    .copyright{height:40px;padding:10px 0;}
    .copyright_nr{width:1000px;height:20px;line-height:20px;}
    .copyright_nr span{color:#fff;cursor:pointer;margin-left:20px;opacity:0.6;}
}
@media (min-width:768px) and (max-width:991px){
    .footer_wrap{width:100%;height:auto;min-height:420px;background:url(../../static/images/footer_bg.jpg) top no-repeat;
        background-size:1920px 100%;}
    .footer{width:750px;height:auto;margin-left:-375px;padding:10px 0 20px;}
    .footer_left{height:auto;width:100%;}
    .footer_text{width:100%;min-height:115px;padding-top:5px;}
    .footer_text .footer_text_li{width:100%;min-height:115px;display:block;float:left;position:relative;height:auto;
        font-size:14px;color:#fff;padding:5px 0;line-height:20px;margin-left:0;border-bottom:1px solid;border-color:rgba(255,255,255,0.1);}
    .footer_text .footer_text_li:nth-child(2n-1){margin-left:0;}
    .footer_right{display:none;}
    .copyright{min-height:40px;padding:10px 15px;height:auto;}
    .copyright_nr{width:100%;min-height:20px;line-height:20px;text-align:center;height:auto;}
    .copyright_nr b{display:inline;}
    .copyright_nr span{color:#fff;cursor:pointer;opacity:0.6;display:inline;vertical-align:top;}
}
@media (max-width:768px){
    .footer_wrap{width:100%;min-height:40px;height:auto;background:url(../../static/images/footer_bg.jpg) top no-repeat;
        background-size:1920px 100%;}
    .footer{width:100%;min-height:420px;height:auto;margin-left:0;padding:10px 0;left:0;display:none;}
    .footer_left{height:auto;width:100%;padding:0 15px;}
    .footer_text{width:100%;min-height:90px;padding-top:5px;}
    .footer_text .footer_text_li{width:100%;min-height:61px;display:block;float:left;position:relative;height:auto;
        font-size:12px;color:#fff;padding:10px 0;line-height:20px;margin-left:0;border-bottom:1px solid;border-color:rgba(255,255,255,0.1);}
    .footer_text .footer_text_li:nth-child(2n-1){margin-left:0;}
    .footer_text .footer_text_li b{width:100%;padding-right:15px;min-height:20px;font-size:15px;color:#fff;display:inline-flex;align-items:flex-end;
        float:left;line-height:20px;}
    .footer_text .footer_text_li span{color:#fff;opacity:0.8;min-height:20px;height:auto;width:390px;display:inline !important;align-items:flex-end;
        overflow: hidden;text-overflow: -o-ellipsis-lastline;text-overflow: ellipsis;margin-top:10px;
        -webkit-line-clamp:2;-webkit-box-orient: vertical;}
    .footer_right{display:none;}
    .copyright{min-height:40px;padding:10px 15px;height:auto;}
    .copyright_nr{width:100%;min-height:20px;line-height:20px;text-align:center;height:auto;}
    .copyright_nr b{display:inline !important;}
    .copyright_nr span{color:#fff;cursor:pointer;opacity:0.6;display:inline !important;vertical-align:top;}
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue